export const formatTicketSegment = (ticketNumber: number | null | undefined): string => {
  if (ticketNumber == null) return 'END';
  return (Number(ticketNumber) % 1000).toString().padStart(3, '0');
};

export const formatPackTicketRange = (
  startingTicketNumber: number | null | undefined,
  endingTicketNumber: number | null | undefined
): string => `${formatTicketSegment(startingTicketNumber)}-${formatTicketSegment(endingTicketNumber)}`;

export const computePackSoldAmount = (
  qtySold: number | null | undefined,
  costPerTicket: number | null | undefined
): number => (Number(qtySold ?? 0) || 0) * (Number(costPerTicket ?? 0) || 0);

